const externalRoutes = {
  Banking: {
    downloadStatements:
      import.meta.env.VITE_API_URL + "/banking/download-statements",
    downloadTransactions:
      import.meta.env.VITE_API_URL + "/banking/download-transactions",
  },
  Stripe: {
    root: `https://billing.stripe.com/p/login/${
      import.meta.env.VITE_STRIPE_LOGIN
    }`,
  },
};

export default externalRoutes;
